import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check, X, ShieldAlert, Activity, BookOpen, Calendar, Award } from 'lucide-react';
export function ProtocoloPro() {
  const comparisons = [{
    sit: 'Querés saber si las actividades funcionan',
    sin: 'No tenés forma de medirlo',
    con: 'Sistema de seguimiento semanal y mensual'
  }, {
    sit: 'Notás algo diferente en tu familiar',
    sin: 'No sabés si es grave o normal',
    con: 'Semáforo de alertas verde amarillo rojo'
  }, {
    sit: 'Vas al médico y te pregunta cómo está',
    sin: 'No tenés datos concretos',
    con: 'Registro de observación listo para mostrar'
  }, {
    sit: 'Tu familiar no quiere hacer nada',
    sin: 'No sabés cómo motivarlo',
    con: '10 técnicas de persuasión afectiva'
  }, {
    sit: 'Querés un desafío mayor',
    sin: 'Los tomos ya los terminó',
    con: '50 actividades nivel oro de alta complejidad'
  }, {
    sit: 'Querés acompañar mejor',
    sin: 'Improvisás en cada situación',
    con: '4 protocolos de acción para días difíciles'
  }];
  const includes = [{
    icon: Activity,
    title: 'Sistema de seguimiento',
    desc: 'Registro diario, semanal y mensual'
  }, {
    icon: ShieldAlert,
    title: 'Semáforo de alertas',
    desc: 'Verde normal, amarillo observar, rojo consultar'
  }, {
    icon: BookOpen,
    title: 'Test mensual de memoria',
    desc: 'Medición objetiva con registro histórico'
  }, {
    icon: Award,
    title: '50 actividades nivel oro',
    desc: 'Para adultos mayores que quieren más desafío'
  }, {
    icon: ShieldAlert,
    title: '4 protocolos de crisis',
    desc: 'Para días difíciles, dolor, tristeza y rechazo'
  }, {
    icon: BookOpen,
    title: 'Guía de ambientes neuro-saludables',
    desc: 'Cómo organizar el hogar para potenciar la mente'
  }, {
    icon: Calendar,
    title: 'Calendario maestro anual',
    desc: 'Plan de 6 meses completo'
  }, {
    icon: BookOpen,
    title: 'Glosario de salud cognitiva',
    desc: 'Términos simples para entender el proceso'
  }, {
    icon: Award,
    title: 'Certificado de acompañante',
    desc: 'Para reconocer el compromiso de quien cuida'
  }];
  return <section className="py-20 px-4 bg-ivory" data-id="element-254">
      <div className="max-w-5xl mx-auto" data-id="element-255">
        <div className="text-center mb-16" data-id="element-256">
          <h2 className="text-3xl md:text-5xl font-bold text-blue-900 mb-6" data-id="element-257">
            🕊️ ¿QUÉ AGREGA EL PROTOCOLO MENTE VIVA PRO?
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-258">
            Herramientas profesionales adaptadas para familias. Porque estimular
            la mente es el primer paso, pero medir el progreso lo cambia todo.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="overflow-x-auto mb-20 rounded-2xl shadow-sm border border-stone-200" data-id="element-259">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-260">
            <thead data-id="element-261">
              <tr className="bg-cream border-b border-stone-200" data-id="element-262">
                <th className="p-4 font-bold text-slate-700 w-1/3" data-id="element-263">
                  Situación
                </th>
                <th className="p-4 font-bold text-red-700 bg-red-50/50 w-1/3" data-id="element-264">
                  ❌ Sin Protocolo Pro
                </th>
                <th className="p-4 font-bold text-blue-800 bg-blue-50/50 w-1/3" data-id="element-265">
                  ✅ Con Protocolo Pro
                </th>
              </tr>
            </thead>
            <tbody data-id="element-266">
              {comparisons.map((row, i) => <tr key={i} className="border-b border-stone-100 last:border-0" data-id="element-267">
                  <td className="p-4 text-slate-700 font-medium" data-id="element-268">{row.sit}</td>
                  <td className="p-4 text-slate-600 bg-red-50/20" data-id="element-269">{row.sin}</td>
                  <td className="p-4 text-blue-900 font-medium bg-blue-50/20" data-id="element-270">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Includes Grid */}
        <div className="bg-blue-900 rounded-3xl p-8 md:p-12 text-white shadow-xl" data-id="element-271">
          <h3 className="text-2xl md:text-3xl font-bold mb-10 text-center text-amber-400" data-id="element-272">
            ✅ EL PROTOCOLO PRO INCLUYE:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-273">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="bg-blue-800/50 p-5 rounded-xl border border-blue-700 flex gap-4 items-start" data-id="element-274">
                <div className="bg-blue-700 p-2 rounded-lg text-amber-400 flex-shrink-0" data-id="element-275">
                  <item.icon className="w-6 h-6" data-id="element-276" />
                </div>
                <div data-id="element-277">
                  <h4 className="font-bold text-lg mb-1" data-id="element-278">{item.title}</h4>
                  <p className="text-blue-100 text-sm leading-relaxed" data-id="element-279">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}